/* Temporary compatibility bridge for Melco Fusion's Impact adapter on Symmetry.
 * Remove when the app supports Symmetry and normalizes returned color names.
 */
document.addEventListener('DOMContentLoaded', () => {
  const patched = new WeakSet();

  function prepareColorSelectors() {
    const button = document.querySelector('.melco-fusion-personalization-button');
    if ( !button ) {
      return false
    }

    // Fusion looks for this class to read the color option's legend.
    // Resolve the actual option name from the app.
    const colorName = button.dataset.colorOptionName;
    if ( !colorName ) {
      return false
    }

    let found = false;
    const variantSelectors = document.querySelectorAll('variant-picker fieldset[data-option]');

    if ( variantSelectors ) {
      for ( const selector of variantSelectors ) {
        if ( selector.dataset.option === colorName && selector.querySelector('legend') ) {
          selector.classList.add('variant-picker__option');
          found = true;
        }
      }
    }
    return found;
  }

  function install() {
    const colorNameMatchFound = prepareColorSelectors();
    if ( !colorNameMatchFound ) {
      return
    }

    const configurator = window.MelcoConfiguratorInstance;
    if ( !configurator || typeof configurator.start !== 'function' || patched.has(configurator) ) {
      return
    }

    const originalStart = configurator.start;
    configurator.start = function ( productToken, apiKey, options ) {
      prepareColorSelectors();

      if ( typeof options?.onComplete !== 'function' ) {
        return originalStart.apply(this, arguments);
      }

      const originalComplete = options.onComplete;
      const wrappedOptions = {
        ...options,
        onComplete(session, ...args) {
          // Copy rather than mutate the configurator's session. Every blank image
          // must use the same normalized name for Fusion's preview lookups too.
          const images = session?.product?.blank?.images;
          const normalizedSession = Array.isArray(images) ? {
            ...session,
            product: {
              ...session.product,
              blank: {
                ...session.product.blank,
                images: images.map((image) => ({
                  ...image,
                  color_name: typeof image.color_name === 'string'
                    ? image.color_name.trim() : image.color_name
                }))
              }
            }
          } : session;

          prepareColorSelectors();

          return originalComplete.call(this, normalizedSession, ...args);
        }
      }

      return originalStart.call(this, productToken, apiKey, wrappedOptions);
    };

    patched.add(configurator);
  }

  // Capture runs before Fusion's button listener, including after section swaps.
  document.addEventListener('click', (event) => {
    if ( event.target.closest('.melco-fusion-personalization-button') ) {
      install();
    }
  }, true);

  document.addEventListener('shopify:section:load', install);

  install();
})

